import script from "./competenzeList.vue?vue&type=script&setup=true&lang=js"
export * from "./competenzeList.vue?vue&type=script&setup=true&lang=js"

import "./competenzeList.vue?vue&type=style&index=0&id=3f01fc98&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f01fc98"]])

export default __exports__